/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Replace the default "Powered by Shopify" credit with "Designed by RMH Websites".
(function swapFooterCredit() {
  function applySwap() {
    var el = document.querySelector('.footer-copyright__span--powered');
    if (!el) return false;
    if (el.dataset.rmhSwapped === 'true') return true;
    el.innerHTML = 'Designed by <a href="https://www.rmhwebsites.com" target="_blank" rel="noopener">RMH Websites</a>';
    el.dataset.rmhSwapped = 'true';
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applySwap);
  } else {
    applySwap();
  }

  // Re-apply on Shopify theme-editor re-renders (section reload, etc.)
  document.addEventListener('shopify:section:load', applySwap);
  document.addEventListener('shopify:section:reorder', applySwap);
})();
